<template>
  <div class="text-static-default-low caption">
    {{ label }}
  </div>
  <div class="text-action-default-hi body-2 mt-4">
    {{ value }}
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string
  value?: string
}>()
</script>
